import { render } from "./footer-bottom.vue?vue&type=template&id=1f140989&scoped=true"
import script from "./footer-bottom.vue?vue&type=script&lang=js"
export * from "./footer-bottom.vue?vue&type=script&lang=js"

import "./footer-bottom.vue?vue&type=style&index=0&id=1f140989&lang=scss&scoped=true"

import exportComponent from "/home/gebruiker/www/profs-computers/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f140989"]])

export default __exports__